<style  scoped>



</style>

<template>

<div class="c-burger o-wrapper--valign u-fixed u-pos-tr u-marg-t-md u-marg-t-xs@sm" :class="{ 'is-clear': 'clear'===color , 'is-dark': 'dark'===color}">

    <!--<span class="c-burger__label t-text--md t-text--roman u-absolute u-transparent ">Close</span>-->
    <button class="t-btn t-btn--burger o-wrapper--valign u-inline-block u-align-center " @click="onToggleNav">
        <div class="c-burger__border o-wrapper--panel u-fit "></div>
        <div class="c-burger__border o-wrapper--panel u-fit "></div>
        <div class="u-relative u-inline-block u-valign-middle ">
          <span class="t-btn--burger__bar u-block u-relative "></span>
          <span class="t-btn--burger__bar u-block u-relative "></span>
          <span class="t-btn--burger__bar u-block u-relative "></span>
           <span class="t-btn--burger__bar u-absolute u-pos-center u-block ">
             <div class="t-btn--burger__bar__panel o-wrapper--panel u-fit "></div>
           </span>
             <span class="t-btn--burger__bar u-absolute u-pos-center u-block ">
          <div class="t-btn--burger__bar__panel o-wrapper--panel u-fit "></div>
        </span>
        </div>
    </button>
</div>

</template>

<script>

export default {
    name: "app-header",
    props: {
      debug: {
          type: Boolean,
          default: !1
      },
        content: {
            type: Object,
            default: function() {}
        },
        color: {
            type: String,
            default: ""
        }
    },
    created: function() {
        this._isAnimating = !1
    },
    methods:
     {
        onToggleNav: function()
        {
            var t = this;
            if (this.$root.isPopinActive)
            {
               this.eventHub.$emit("close:popin");
               this.eventHub.$emit("close:popinslideout");
               //this.eventHub.$emit("close:popinphotos");
            }
            else
            {
                if (clearTimeout(e), this._isAnimating) return;
                this._isAnimating = !0, this.eventHub.$emit("toggle:nav");
                var e = setTimeout(function() {
                    t._isAnimating = !1
                }, 1300)
            }
        }
    }

}

</script>
